import { MultiCheckboxFilterOption } from '../../../FilterResultsManager/options/types';
import { MultiSelectCheckbox } from '../../../FilterResultsManager/components';

export const config: MultiCheckboxFilterOption = {
  id: 'jaxCancerEffectContent.filters.proteinEffect',
  title: {
    id: 'jaxCancerEffectContent.filters.proteinEffect',
    defaultMessage: 'Protein Effect',
  },
  content: MultiSelectCheckbox,
  injectedProps: {
    searchKey: 'protein_effect',
    checkboxOptions: [
      {
        id: 'jaxCancerEffectContent.filters.proteinEffect.gainOfFunction',
        searchValue: 'gain of function',
        intlLabel: {
          id: 'jaxCancerEffectContent.filters.proteinEffect.gainOfFunction',
          defaultMessage: 'Gain of Function',
        },
      },
      {
        id: 'jaxCancerEffectContent.filters.proteinEffect.gainOfFunctionPredicted',
        searchValue: 'gain of function - predicted',
        intlLabel: {
          id: 'jaxCancerEffectContent.filters.proteinEffect.gainOfFunctionPredicted',
          defaultMessage: 'Gain of Function - Predicted',
        },
        informationText: {
          id: 'mutationBiochemistryContent.filters.proteinEffect.gainOfFunctionPredicted.tooltip',
          defaultMessage:
            'There is peer-reviewed published literature demonstrating that similar gene alterations, both in type and location, have been characterized as gain of function. This is also appropriate if there are limited functional data.',
        },
      },
      {
        id: 'jaxCancerEffectContent.filters.proteinEffect.lossOfFunction',
        searchValue: 'loss of function',
        intlLabel: {
          id: 'jaxCancerEffectContent.filters.proteinEffect.lossOfFunction',
          defaultMessage: 'Loss of Function',
        },
      },
      {
        id: 'jaxCancerEffectContent.filters.proteinEffect.lossOfFunctionPredicted',
        searchValue: 'loss of function - predicted',
        intlLabel: {
          id: 'jaxCancerEffectContent.filters.proteinEffect.lossOfFunctionPredicted',
          defaultMessage: 'Loss of Function - Predicted',
        },
        informationText: {
          id: 'mutationBiochemistryContent.filters.proteinEffect.lossOfFunctionPredicted.tooltip',
          defaultMessage:
            'There is peer-reviewed published literature demonstrating that similar gene alterations, both in type and location, have been characterized as loss of function. This is also appropriate if a gene alteration has not been characterized, but all known functional domains or a key domain (i.e. protein kinase domain) are lost, or if there are limited functional data.',
        },
      },
      {
        id: 'jaxCancerEffectContent.filters.proteinEffect.noEffect',
        searchValue: 'no effect',
        intlLabel: {
          id: 'jaxCancerEffectContent.filters.proteinEffect.noEffect',
          defaultMessage: 'No Effect',
        },
      },
      {
        id: 'jaxCancerEffectContent.filters.proteinEffect.noEffectPredicted',
        searchValue: 'no effect - predicted',
        intlLabel: {
          id: 'jaxCancerEffectContent.filters.proteinEffect.noEffectPredicted',
          defaultMessage: 'No Effect - Predicted',
        },
        informationText: {
          id: 'mutationBiochemistryContent.filters.proteinEffect.noEffectPredicted.tooltip',
          defaultMessage:
            'There is peer-reviewed published literature with modest functional evidence demonstrating that the gene alteration present results in activity similar to that of wild-type and does not demonstrate tumorigenic attributes.',
        },
      },
      {
        id: 'jaxCancerEffectContent.filters.proteinEffect.unknown',
        searchValue: 'unknown',
        intlLabel: {
          id: 'jaxCancerEffectContent.filters.proteinEffect.unknown',
          defaultMessage: 'Unknown',
        },
      },
    ],
  },
};
